var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 36,
    rx: 18,
    fill: "url(#pattern0_217_768)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_217_768",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_217_768",
    transform: "scale(0.0192308 0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_217_768",
    width: 52,
    height: 36,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAkCAYAAADGrhlwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAABP9JREFUeAHNmU9MFGcYxp/ZYV3YRdhaCBABF4HWEhvXxEMTeii9aD1heqheZDmIaUwVmgA9VIHQJi02YZGmjfQAnEqTUj00TbkUm1SbxjYu6R+qAV2E1hUMIsLCwv7p907ZdWVnvp2PXXB/CSzMfDszzzzv977vfCNhjdANWGEw1ENCjfNega3t352Y86chFbGm+dG6cwpn8jwudr0uBIJt0n64aZ9Ev5gYO2TDMI0Nf8ntM+HIrRfh8pqRSryWNY/e3eOwmXzRm91M1BEmyiUxMbY1MTa1A7RNFaL1n0KkAs5dbpzJ92jtnmOi9kuuQWPvvvKAg3cgcqtqtEL5fBbYzV70lo4pnzx+HZWd8uDw806EYK20+zUHWtMCqGd3huLzyuMsbCV0XpUQe4pHCxLae8xo+MSSL+Xk5IRoY1FeEJc751GcH+Se4Mp8Fmpvl266WySAhNCc4fH7mIzTH2fij3FZ+V82m82t9Mf8ooSewXRITB7PLTqRI+cBPH4jRrwWbAbkypdlY9iTscQdd/HrdNSc247ph4bItohD0ewtDaC//XFct/pmctHGEkay3KJ03FtyG9U7Zrnj7noMeIe5cm0ktqxEHIqGFH81ZILJCByo0HbLbvGi+rmHmAukJewWhdbPFX+yYy5yx5Erde2ZGJuUVferCiJ8KxJ+uG7EpEfG3jI/sjNDqgeghEGirHIAvyxmYjlogAjkykdFd/F5yR2kG7Qjgib+W81Z6P/WBN+qpDlONeTWQwmjsWYJxw75uONEi7FGkYzhu5+MSojRPI+HLkFhjh5cwQenFjXdCqOnGMcpkgrkSkdfBnq+SYdehAQR5FZ38wI3ExJaxVhvkbzqIlcsmLwvFsKac0gLsn2AJYx46V2tGIsUyUanRVeIrUfYoWhEijEhWiQ3QkKCwjQdX0KjYwmJQOn4/c8S7+yTIojQW4zXwyuSG0FsxnGgMHm9Llu503qhsVUnspMmhkiaoDCSyDxmmUUSn/f8QyYr5Crtq+huWkSRYMhNspA7fnZ7QokgmqQI+vCUF3VvLiMROvozcJ79JEpCgl4uC+BC0wLr9QLccXrTNrlV/W6Wkig2inBhDXOSOdLdzA8xWjV6b7IYb7tL0P8gV1mS4YmilurkmtPXRozYCMIOUVq+QK3PPn7rQw1q7XhZTKNKXcLwS3/FbUip9TndYRF2S8ghuntfnF1AeTF/4js9+UrX7VmNvcv07NTlKYjrFt24owd9mJ41sIShP63rcohCgRrSNypXueOoEXWMl+JHnQsp1KBeeuFmXLcGhraxhGHW5VZchygdf//pfNyJT64cGy/HzWX9mYocpLlFD3avZC5ojqNzH65cURrXeG5pCiJXzp1YwvkGL0zbtA9AE//Q33twcTpP+GmVoO8MPbJigrlLj/TUpWtdz+FXV9lnEL+NGpUnajVUQ05vkbw8uwO1d3YnbQ2cQq+FrVk7cme443jFOEaQniJJAuiJtIuF2WbgyJlB564JZb2Bh1oxjggSKZKptNC4vhjLFovFwdKxVaRIUurdbOgcosX4qivNLV0fMHYeqAjU8w6uVSS3Cr3FeOSW3Bd+nXIDUe+GoqF03DBhQyrQUjilvOhSJRRyIxiqevLCyyBdYg8ntvB+0SK5VagX4xB7N8TE0AuvyKb/nWphSu3O+wV2WrNO5VeSlN7r8++52fX2IYguJmaO9v0HBphXMAz5WJEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.022d892304d1fea11d71aea9cc9951e9.svg";
export { ForwardRef as ReactComponent };